import React, { useState } from 'react'
import { Fab, Tooltip, Zoom } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import OwlIcon from './OwlIcon'
import { useTranslation } from 'react-i18next'
import useAuth from '@/context/useAuth'
import { isAgridBotEnabled } from '@/utils/agridBot'
import { useAssistant } from '@/hooks/useAssistant'
import AssistantPanel from './AssistantPanel'

const AssistantWidgetInner = () => {
    const { t } = useTranslation('assistant')
    const [open, setOpen] = useState(false)
    const assistant = useAssistant()

    return (
        <>
            {open && (
                <AssistantPanel
                    exchanges={assistant.exchanges}
                    asking={assistant.asking}
                    askFailed={assistant.askFailed}
                    conversations={assistant.conversations}
                    activeThreadId={assistant.threadId}
                    onAsk={assistant.ask}
                    onNewConversation={assistant.newConversation}
                    onOpenHistory={assistant.loadConversations}
                    onOpenThread={assistant.openThread}
                    onFeedback={assistant.feedback}
                    onClose={() => setOpen(false)}
                />
            )}
            <Zoom in>
                <Tooltip title={open ? t('close') : t('openLabel')}>
                    <Fab
                        color="primary"
                        aria-label={t('openLabel')}
                        onClick={() => setOpen((current) => !current)}
                        sx={{
                            position: 'fixed',
                            bottom: 24,
                            right: 24,
                            zIndex: 'modal',
                        }}
                    >
                        {open ? <CloseIcon /> : <OwlIcon />}
                    </Fab>
                </Tooltip>
            </Zoom>
        </>
    )
}

// The in-house assistant is the default. Chatbase replaces it only when the
// persisted ?agridbot=false switch is set (see index.html).
const AssistantWidget = () => {
    const { me } = useAuth()
    if (!isAgridBotEnabled() || !me) return null
    return <AssistantWidgetInner />
}

export default AssistantWidget
